<template>
  <div class="compute-container">
    <div class="banner">
      <div class="banner-content">
        <h1>长三角算力资源市场</h1>
        <p>
          依托长三角地区丰富的数据中心和算力资源，提供高性能计算、人工智能训练推理、大数据处理等多样化算力服务，助力数字经济发展。
        </p>
      </div>
    </div>

    <div class="main-content">
      <div class="feature-cards">
        <el-card class="feature-card">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="feature-card">
                <div class="feature-card-title">
                  <img class="icon" src="../../assets/img/suanli.png" alt="" />
                  <div class="title">算力加速</div>
                </div>
                <p class="feature-card-remark">
                  提供多样化的算力资源，包括GPU、CPU、FPGA等，满 足不同场景需求
                </p>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="feature-card">
                <div class="feature-card-title">
                  <img
                    class="icon"
                    src="../../assets/img/anquankekao.png"
                    alt=""
                  />
                  <div class="title">安全可靠</div>
                </div>
                <p class="feature-card-remark">
                  多重安全防护，确保数据安全，服务稳定可靠，7*24小时运维支持
                </p>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="feature-card">
                <div class="feature-card-title">
                  <img
                    class="icon"
                    src="../../assets/img/lingghuojifei.png"
                    alt=""
                  />
                  <div class="title">灵活计费</div>
                </div>
                <p class="feature-card-remark">
                  按需付费，灵活的计费模式，助力企业降本增效
                </p>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>

      <div class="market-section">
        <div class="market-section-title">资源市场</div>
        <div class="filter-section">
          <el-row :gutter="20">
            <el-col :span="24" :style="{ marginBottom: '12px' }">
              <el-input
                placeholder="搜索算力资源名称"
                v-model="filters.goodsName"
                prefix-icon="el-icon-search"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="24" :style="{ marginBottom: '12px' }">
              <div class="filter-form">
                <span class="filter-form-label">算力分类</span>
                <div class="filter-form-value">
                  <span
                    v-for="(item, index) in typeOptions"
                    :key="index"
                    @click="filters.goodsCategory = item.value"
                    class="filter-form-value-item"
                    :class="
                      filters.goodsCategory === item.value
                        ? 'filter-form-value-active'
                        : ''
                    "
                    >{{ item.name }}</span
                  >
                </div>
              </div>
            </el-col>
            <el-col :span="24" :style="{ marginBottom: '12px' }">
              <div class="filter-form">
                <span class="filter-form-label">所在地区</span>
                <div class="filter-form-value">
                  <span
                    v-for="(item, index) in regionOptions"
                    :key="index"
                    @click="filters.region = item.value"
                    class="filter-form-value-item"
                    :class="
                      filters.region === item.value
                        ? 'filter-form-value-active'
                        : ''
                    "
                    >{{ item.name }}</span
                  >
                </div>
              </div>
            </el-col>
            <el-col :span="24" :style="{ marginBottom: '12px' }">
              <div class="filter-form">
                <span class="filter-form-label">所属公司</span>
                <div class="filter-form-value">
                  <span
                    v-for="(item, index) in companyOptions"
                    :key="index"
                    @click="filters.companyName = item.value"
                    class="filter-form-value-item"
                    :class="
                      filters.companyName === item.value
                        ? 'filter-form-value-active'
                        : ''
                    "
                    >{{ item.name }}</span
                  >
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="product-list">
          <el-row :gutter="24">
            <el-col :span="8" v-for="item in products" :key="item.id">
<!--              <el-card class="product-card" shadow="never">-->
<!--                <div-->
<!--                  class="product-tag"-->
<!--                  :class="item.inventoryStatus == 1 ? 'product-tag-active' : ''"-->
<!--                >-->
<!--                  {{ item.inventoryStatus == "1" ? "充足" : "紧张" }}-->
<!--                </div>-->
<!--                <h3>{{ item.goodsName }}</h3>-->
<!--                <el-tooltip placement="top">-->
<!--                  <div slot="content">-->
<!--                    <span-->
<!--                      v-html="formattedTextBr(item.goodsDescription)"-->
<!--                    ></span>-->
<!--                  </div>-->
<!--                  <p class="description">-->
<!--                    {{ item.goodsDescription.replace(/\n/g, "｜") }}-->
<!--                  </p>-->
<!--                </el-tooltip>-->

<!--                <div class="location">-->
<!--                  <img-->
<!--                    class="location-icon"-->
<!--                    src="../../assets/img/diqv.png"-->
<!--                    alt=""-->
<!--                  />-->
<!--                  <span>-->
<!--                    {{-->
<!--                      regionOptions.find((jtem) => jtem.value === item.region)-->
<!--                        ?.name || item.region-->
<!--                    }}-->
<!--                  </span>-->
<!--                </div>-->
<!--                <div class="price">-->
<!--                  &lt;!&ndash; <span class="unit">¥</span> &ndash;&gt;-->
<!--                  <span class="amount">{{ item.billingMethod }}</span>-->
<!--                  &lt;!&ndash; <span class="unit">/卡/小时</span> &ndash;&gt;-->
<!--                </div>-->
<!--                <div class="actions">-->
<!--                  <span class="actions-btn zixun-btn" @click="showDetail(item)"-->
<!--                    >咨询</span-->
<!--                  >-->
<!--                  <span class="actions-btn order-btn" @click="orderNow(item)"-->
<!--                    >订购</span-->
<!--                  >-->
<!--                </div>-->
<!--              </el-card>-->
              <el-card class="product-card" shadow="never" border>
                <!-- 1. 商品头部：名称 + 地区标签 + 库存标签（贴合附件排版） -->
                <div class="product-header">
                  <h3 class="product-name">{{ item.goodsName }}</h3>
                  <div class="product-tag-group">
                    <span class="region-tag">{{ getRegionName(item.region) }}</span>
                    <span v-if="item.companyName" class="company-tag">{{ item.companyName }}</span>
                    <span
                        class="stock-tag"
                        :class="item.inventoryStatus === 1 ? 'stock-sufficient' : 'stock-tight'"
                    >
                    {{ item.inventoryStatus === 1 ? "资源充足" : "已售罄" }}
                    </span>
                  </div>
                </div>

                <!-- 2. 价格区域（贴合附件大字体突出，移除时长/月相关） -->
                <div class="product-price">
                  <span class="price-type">￥</span>
                  <span class="price-amount">{{ item.billingMethod }}</span>
                </div>

                <!-- 3. 配置分项（保留5项左右对齐，贴合附件规整样式） -->
<!--                <div class="config-table">-->
<!--                  <div class="config-row" v-for="(item, index) in configItems" :key="index">-->
<!--                    <span class="config-label">{{ item.label }}：</span>-->
<!--                    <span class="config-value">{{ getConfigValue(item.product, item.key) }}</span>-->
<!--                  </div>-->
<!--                </div>-->
                <div class="config-wrapper">
                  <div class="description-container">
                    <div class="description-row"
                         v-for="(group, groupIndex) in formatGoodsToGroups(item.goodsDescription)"
                         :key="groupIndex">
                      <div class="description-item"
                           v-for="(config, itemIndex) in group"
                           :key="itemIndex">
                        <div class="config-wrap">
                          <span class="config-key">{{ config.key }}：</span>
                          <!-- 仅保留value的悬浮提示 -->
                          <el-tooltip :content="config.value" placement="top">
                            <span class="config-value">{{ config.value }}</span>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 4. 操作按钮（贴合附件蓝色主按钮，样式规整） -->
                <div class="product-actions">
                  <el-button
                      type="default"
                      class="consult-btn"
                      @click="showDetail(item)"
                  >
                    咨询
                  </el-button>
                  <el-button
                      type="primary"
                      class="order-btn"
                      @click="orderNow(item)"
                      :disabled="item.inventoryStatus !== 1"
                  >
                    立即购买
                  </el-button>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <div class="empty-block" v-if="products.length === 0">
            <img
              src="../../assets/img/queshengye.png"
              alt="暂无数据"
              class="empty-image"
            />
            <div class="empty-text">暂无数据</div>
          </div>
        </div>

        <div class="pagination">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :page-sizes="[9, 30, 60, 90, 100]"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { goodsPage, goodsCompanies } from "@/api/index";
import { mapGetters, mapActions } from "vuex";
import { gotoReLogin, isNcnpUser } from "@/utils/ncnp";
import { getToken } from "@/utils/auth";
import { updateUrlParameters } from "@/utils/index";
export default {
  name: "ComputeIndex",
  data() {
    return {
      filters: {
        goodsCategory: "",
        region: "",
        companyName: "",
        goodsName: "",
      },
      companyOptions: [],
      pageSize: 9,
      searchTimeout: null,
      loading: false,
      products: [],
      currentPage: 1,
      total: 0,
      typeOptions: [
        {
          value: "",
          name: "全部",
        },
        {
          value: "1",
          name: "智算",
        },
        {
          value: "2",
          name: "超算",
        },
        {
          value: "3",
          name: "通算",
        },
        {
          value: "4",
          name: "量算",
        },
      ],
      regionOptions: [
        {
          value: "",
          name: "全部",
        },
        { name: "上海", value: 1 },
        { name: "江苏", value: 2 },
        { name: "浙江", value: 3 },
        { name: "安徽", value: 4 },
      ],
    };
  },
  computed: {
    ...mapGetters(["type"]),
  },
  methods: {
    splitKeyAndValue(item) {
      if (!item) return { key: '', value: '' };
      // 匹配中英文冒号（优先匹配中文冒号，再匹配英文冒号）
      const colonIndex = item.indexOf('：') !== -1
          ? item.indexOf('：')
          : item.indexOf(':');
      if (colonIndex === -1) {
        return { key: '', value: item }; // 无冒号时，全部作为 value
      }
      const key = item.slice(0, colonIndex).trim();
      const value = item.slice(colonIndex + 1).trim();
      return { key, value };
    },
    formatGoodsToGroups(goodsText) {
      if (!goodsText) return [];
      // 步骤1：按\n拆分，过滤空数据
      const singleItems = goodsText.split('\n').filter(item => item.trim() !== '');
      // 步骤2：拆分每个项为 key/value
      const keyValueItems = singleItems.map(item => this.splitKeyAndValue(item));
      // 步骤3：每2个一组分组
      const resultGroups = [];
      for (let i = 0; i < keyValueItems.length; i += 2) {
        const group = keyValueItems.slice(i, i + 2);
        resultGroups.push(group);
      }
      return resultGroups;
    },
    getRegionName(regionValue) {
      if (!this._regionMap) {
        this._regionMap = new Map(
            this.regionOptions.map(option => [option.value, option.name])
        );
      }
      return this._regionMap.get(regionValue) || regionValue;
    },
    ...mapActions("user", ["checkTokenValidity"]),
    showDetail(item) {
      // 实现查看详情逻辑
      let info = `<p style="margin: 0 0 10px 30px;">请拨打电话联系我们：</p><p style="font-weight: 666;margin-left: 30px;
        font-size: 20px;">${item.consultationMethod}</p>`;
      this.$alert(info, "咨询", {
        confirmButtonText: "确定",
        showClose: false,
        dangerouslyUseHTMLString: true,
        callback: (action) => {},
      });
    },
    async orderNow(item) {
      // 法人身份过滤（CA/NCNP 通用）
      if (this.type == 1) {
        this.$alert("仅支持「法人」身份订购", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          callback: (action) => {},
        });
        return;
      }
      if (!item || !item.id) return;

      // CA 用户：直跳外部平台下单（不经本站订购页 / 后端下单接口）。
      // 恢复 NCNP 对接前的链路：subscriptionLink 为运营在后台配置的外部订购页 URL，
      // token 随 query 透传给外部平台。NCNP 用户继续走本站订购页，两条链路互不影响。
      if (!isNcnpUser()) {
        const subscriptionLink = item.subscriptionLink;
        if (!subscriptionLink) {
          this.$alert("该商品暂未配置订购入口", "提示", {
            confirmButtonText: "确定",
            showClose: false,
            callback: (action) => {},
          });
          return;
        }
        let res = await this.checkTokenValidity();
        if (!res.isValid) {
          // CA 未登录：跳 CA SSO（gotoReLogin 内部按 loginSource 分流）
          gotoReLogin();
          return;
        }
        let link = "";
        if (item.region == 1) {
          // 上海：补 PaaS 通道参数
          link = updateUrlParameters(subscriptionLink, {
            type: "Shanghai",
            redirect_target: "computility",
            token: getToken(),
          });
        } else {
          // 外省：补 usertoken
          link = updateUrlParameters(subscriptionLink, {
            usertoken: getToken(),
          });
        }
        window.open(link, "_blank");
        return;
      }

      // NCNP 用户：走本站订购页（已接通链路，保持不动）
      const placePath = `/orders/place?goods_id=${item.id}`;
      let res = await this.checkTokenValidity();
      if (!res.isValid) {
        // 未登录：按 loginSource 分流（NCNP welcome / CA SSO），回跳本地订购页
        gotoReLogin(placePath);
        return;
      }
      // 已登录：直接跳本地订购页（自做 /orders/place 承担详情+下单）
      this.$router.push({ path: "/orders/place", query: { goods_id: item.id } });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchProducts();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchProducts();
    },
    async fetchCompanies() {
      try {
        const res = await goodsCompanies();
        const list = (res && res.data) || [];
        // "全部" + 去重公司名
        this.companyOptions = [
          { value: "", name: "全部" },
          ...list.map((name) => ({ value: name, name })),
        ];
      } catch (e) {
        console.error("获取所属公司列表失败:", e);
      }
    },
    async fetchProducts() {
      this.loading = true;
      try {
        const params = {
          current: this.currentPage,
          size: this.pageSize,
          goodsStatus: 1,
          ...this.filters,
        };
        const res = await goodsPage(params);
        this.products = res.data.records || [];
        this.total = res.data.total || 0;
      } catch (error) {
        console.error("获取算力资源列表失败:", error);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.fetchProducts();
      }, 300);
    },
  },
  watch: {
    "filters.goodsCategory"() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    "filters.region"() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    "filters.companyName"() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    "filters.goodsName"() {
      this.currentPage = 1;
      this.handleSearch();
    },
  },
  created() {
    this.fetchCompanies();
    this.fetchProducts();
  },
};
</script>

<style scoped lang="scss">
.compute-container {
  .banner {
    height: 320px;
    /* background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%); */
    color: white;
    display: flex;
    align-items: center;
    background-image: url("../../assets/bg/suanlishichangbanner.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .banner-content {
      padding: 0 241px;

      h1 {
        font-size: 48px;
        margin-bottom: 16px;
      }

      p {
        font-size: 16px;
        opacity: 0.9;
        margin-bottom: 60px;
      }
    }
  }

  .main-content {
    margin: -60px auto 0;
    padding: 0 241px;
    position: relative;
    z-index: 1;

    .feature-cards {
      margin-bottom: 48px;

      ::v-deep .el-card__body {
        padding: 45px;

        .el-col {
          padding: 0 !important;
          padding-right: 50px !important;
        }

        .el-col:not(:last-child) {
          border-right: 1px solid #e8e8e8;
        }
        .el-col:not(:first-child) {
          padding-left: 24px !important;
        }
      }

      .feature-card {
        height: 100%;

        .feature-card-title {
          display: flex;
          align-items: center;
          .icon {
            width: 31px;
            height: 31px;
            margin-right: 10px;
          }
          .title {
            font-weight: bold;
            font-size: 18px;
            color: #151519;
          }
        }

        .feature-card-remark {
          font-size: 16px;
          color: #656565;
          line-height: 26px;
          margin-bottom: 0;
        }
      }
    }

    .market-section {
      background: white;
      /* padding: 32px; */
      /* border-radius: 8px; */
      /* box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); */

      .market-section-title {
        font-size: 24px;
        margin-bottom: 20px;
      }

      .filter-section {
        margin-bottom: 24px;

        .filter-form {
          display: flex;
          align-items: center;
          .filter-form-label {
            width: 90px;
            color: #999999;
            font-size: 16px;
          }

          .filter-form-value {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .filter-form-value-item {
              padding: 6px 12px;
              border-radius: 2px;
              margin-right: 12px;
              cursor: pointer;
              transition: all 0.3s ease;
              background: transparent;
              color: #333;
            }
            .filter-form-value-active {
              background: #057bf3;
              color: white;
            }
          }
        }
      }

      .product-list {
        margin-bottom: 32px;

        ::v-deep .el-row {
          margin-left: -6px !important;
          margin-right: -6px !important;
          display: flex;
          flex-wrap: wrap;

          .el-col {
            padding-left: 6px !important;
            padding-right: 6px !important;
          }
        }

        .product-card {
          width: 100%;
          height: 290px; /* 固定卡片高度（根据你的布局调整） */
          position: relative;
          margin-bottom: 24px;
          padding: 16px;
          box-sizing: border-box; /* 保证padding不撑大卡片 */
          display: flex;
          flex-direction: column;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); // 阴影弱化，更轻盈

          ::v-deep .el-card__body {
            padding: 0;
            height: 100%;
            display: flex;
            flex-direction: column; // 卡片内部也用纵向flex，继承父布局
          }

          h3 {
            font-size: 20px;
            font-weight: 500;
            color: #251f2a;
            margin: 0 0 12px;
          }
        }

        .product-card:hover {
          background: #ecf5ff;
          border: 1px solid #057bf3;
        }
        .config-wrapper {
          flex: 1; // 关键：占满卡片剩余空间，压缩无效空隙
          overflow: hidden; // 防止内容过多撑大卡片
        }
        .empty-block {
          padding: 100px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .empty-image {
            width: 318px;
          }
          .empty-text {
            font-weight: bold;
            font-size: 18px;
            color: #999999;
            margin-left: 18px;
            line-height: 20px;
          }
        }
        /* 1. 商品头部：贴合附件排版（名称在上，标签在下并排） */
        .product-header {
          margin-bottom: 12px;
        }
        .product-name {
          font-size: 15px;
          font-weight: 600;
          color: #333;
          margin: 0 0 4px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .product-tag-group {
          display: flex;
          gap: 6px;
          align-items: center;
        }
        .region-tag {
          background-color: #fff2e8;
          color: #fa8c16;
          padding: 1px 6px;
          border-radius: 4px;
          font-size: 11px;
        }
        .company-tag {
          background-color: #e7f3fe;
          color: #057bf3;
          padding: 1px 6px;
          border-radius: 4px;
          font-size: 11px;
        }
        .stock-tag {
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 12px;
        }
        .stock-sufficient {
          background-color: #f0fff4;
          color: #52c41a;
        }
        .stock-tight {
          background-color: #fff1f0;
          color: #ff4d4f;
        }

        /* 2. 价格区域：贴合附件大字体突出展示 */
        .product-price {
          margin-bottom: 12px;
        }
        .price-type {
          color: #2468f1;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          line-height: 16px;

        }
        .price-amount {
          font-size: 24px;
          font-weight: 700;
          color: #2468f1;
        }

        /* 3. 配置分项：贴合附件左右对齐规整表格样式*/

        // 配置项容器：100% 宽度，避免溢出
        .description-container {
          width: 100%;
          font-size: 12px; // 统一字体大小，提升适配性
          color: #666; // 配置项文字颜色稍浅，突出重点
          margin-bottom: 12px; // 与操作按钮保持间距
        }

        // 每行容器：2个配置项横向排列，均匀分布
        .description-row {
          display: flex;
          justify-content: space-between; // 两端对齐，避免中间空隙不均
          align-items: flex-start; // 顶部对齐，避免因换行导致的错位
          margin-bottom: 12px; // 行间距缩小，更紧凑
          gap: 36px;
        }

        // 单个配置项：占比 48%，预留间距
        .description-item {
          width: 48%; // 固定宽度，避免两个项宽度不均
          min-width: 0;
        }

        // 单个配置项的包裹容器：Flex 布局实现 key/value 对齐
        .config-wrap {
          display: flex;
          align-items: flex-start; // 顶部对齐，适配 value 换行场景
        }

        // 配置项 key：固定宽度 + 右对齐
        .config-key {
          //width: 80px; // 固定宽度（根据常见 key 长度调整，如“计算卡型号”“CPU核数”等）
          text-align: left; // 右对齐，让冒号对齐
          margin-right: 4px; // key 与 value 间距
          color: #999; // key 颜色灰色，突出 value
          flex-shrink: 0; // 禁止 key 收缩，确保宽度固定
        }

        // 配置项 value
        .config-value {
          flex: 1;
          min-width: 0;
          word-break: break-all;
          line-height: 1.5;
          /* 核心省略样式 */
          white-space: nowrap; /* 禁止换行 */
          overflow: hidden; /* 隐藏溢出内容 */
          text-overflow: ellipsis; /* 溢出显示... */
          cursor: pointer; /* 鼠标悬浮显示指针，提示可交互 */
        }

        /* 最后一行去掉底部间距 */
        .description-row:last-child {
          margin-bottom: 0;
        }

        /* 4. 操作按钮：贴合附件并排样式，按钮规格统一 */
        .product-actions {
          display: flex;
          gap: 0px;
          width: 100%;
          margin-top: auto; // 关键：自动顶到底部，实现所有卡片按钮对齐
        }
        .consult-btn {
          flex: 1; // 咨询按钮占1份宽度
          height: 36px; // 按钮高度从40px缩减至36px，更协调
          font-size: 12px;
          border-radius: 4px;
          background: #fff; // 咨询按钮改为白色（原蓝色错误）
          color: #1890ff; // 咨询按钮文字蓝色
          border: 1px solid #1890ff; // 咨询按钮边框蓝色
          &:hover {
            background: #f5faff; // hover色改为浅蓝色背景
            border-color: #40a9ff;
          }
          &:disabled {
            background: #f5f7fa;
            color: #8cc1ff;
            border-color: #bdd7ff;
          }
        }
        .order-btn {
          flex: 2; // 立即购买按钮占2份宽度（是咨询的2倍）
          height: 36px;
          font-size: 12px;
          border-radius: 4px;
          background: #1890ff; // 立即购买按钮蓝色（正确）
          border: none;
          &:hover {
            background: #40a9ff;
          }
          &:disabled {
            background: #e6f0ff;
            color: #8cc1ff;
            cursor: not-allowed;
          }
        }

        @media screen and (max-width: 1200px) {
          .description-row {
            flex-direction: column; // 小屏幕下每行1个配置项
          }
          .description-item {
            width: 100%;
            margin-bottom: 6px;
          }
        }
      }

      .pagination {
        text-align: center;
        margin-top: 32px;
        margin-bottom: 60px;
      }
    }
  }
}
</style>
